<template>
    <collapsible-card :title="'Provider Information'" v-show="showInfo" ref="cCard">
        <div class="cardContent">
            <div class="category">
                <div v-for="obj in general" :key="obj.field" class="dataItem">
                    <p v-if="obj.val != undefined">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                    <p v-else-if="obj.link"><a :href="obj.link" class="dataEmphasis link" target="_blank">{{obj.field}}</a></p>
                    <p v-else><span class="dataEmphasis">{{obj.field}}</span></p>
                </div>
            </div>
            <provider-platform-table ref="pPlatform"/>
            <provider-lease-table ref="pLease"/>
        </div>
    </collapsible-card>
</template>

<script>
import { readFromObj } from '../../helpers/Formatting.js';
import CollapsibleCard from '../CollapsibleCard.vue';
import ProviderPlatformTable from './ProviderPlatformTable.vue';
import ProviderLeaseTable from './ProviderLeaseTable.vue';

export default {
    name: 'provider-info',
    components: {
        ProviderPlatformTable,
        ProviderLeaseTable,
        CollapsibleCard
    },
    data: () => ({
        general: [],
        showInfo: false
    }),
    methods: {
        updateInfo: function(provideInfo) {
            var globv = this;

            globv.$refs.pPlatform.updateInfo(provideInfo['platformsVisited']);
            globv.$refs.pLease.updateInfo(provideInfo['leasesVisited']);

            let expectedVariables = [
                {
                    varName: "supplyVessels.numInPort",
                    fieldName: "Number of Vessels in Port"
                },
                {
                    varName: "website",
                    fieldName: "Website",
                    link: true
                },
            ]

            globv.general = readFromObj(provideInfo, expectedVariables);

            globv.showInfo = globv.general.length > 0;
            globv.$refs.cCard.adjustHeight();
        },
        reset: function () {
            var globv = this;
            globv.general = [];
            globv.showInfo = false;
        }
    }
}
</script>